import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface VersionState {
  isUpdateAvailable: boolean;
}

interface VersionActions {
  setUpdateAvailable: (available: boolean) => void;
}

export type VersionStore = VersionState & VersionActions;

const initialState: VersionState = {
  isUpdateAvailable: false,
};

export const useVersionStore = create<VersionStore>()(
  devtools(
    (set) => ({
      ...initialState,
      setUpdateAvailable: (available: boolean) =>
        set({ isUpdateAvailable: available }, undefined, "version/setUpdateAvailable"),
    }),
    {
      name: "version-store",
    },
  ),
);
